import { Share, Society } from 'types';

const getNominalValue = (share: Share, society: Society) => {
  const { shareClass } = share;

  if (typeof shareClass !== 'string' && shareClass?.nominalValue) {
    return shareClass.nominalValue;
  }

  return society?.nominalValue || 0;
};

/**
 * @deprecated
 * in favor of getPartnerInversionFromOperations (API)
 */
export const getPartnerAmount = (
  partnerShares: Share[],
  society: Society
): number => {
  if (!society || !partnerShares?.length) return 0;

  const result = partnerShares?.reduce((acc, share) => {
    let result = 0;

    const shareCount = share.to - share.from + 1;
    const nominalValue = getNominalValue(share, society);

    if (share.sharePrice) {
      result = share.sharePrice * shareCount;
    } else {
      result = (nominalValue + (share.sharePremium || 0)) * shareCount;
    }

    return acc + result;
  }, 0);

  return result;
};
